// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'
import store from './store/index.js'

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
/* 重置样式 */
import './assets/css/reset.min.css'
/* animate.css */
import 'animate.css'

/* 重置样式 */
import './assets/css/common.scss'

// cookie 处理
import '@/utils/cookieStore.js'
// 引入全局 百度统计
import '@/utils/hmt.js'


import { Loading, Dialog,Pagination} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Dialog);
Vue.use(Loading);
Vue.use(Pagination);


 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

import i18n from './i18n/index'


Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js